import upperFirst from 'lodash-es/upperFirst';

import type {
  StaffMember,
  StaffMemberWithIdAndStoreNames,
} from '@jane/business-admin/types';

import { ROLE_LABEL_MAPPING } from './permissionsHelpers';

export const formatRole = (
  staffMember: StaffMember | StaffMemberWithIdAndStoreNames
) => {
  if (staffMember.role === 'staff_member') {
    const reservationModes = [
      staffMember.pickup && 'Pickup',
      staffMember.delivery && 'Delivery',
    ]
      .filter(Boolean)
      .join(' & ');
    return `${ROLE_LABEL_MAPPING['staff_member']} - ${reservationModes}`;
  }

  return upperFirst(ROLE_LABEL_MAPPING[staffMember.role]);
};
